export default __webpack_public_path__ + "img/bg-tab1and2_nav3-f227660d.png";